// src/components/EbookSlider.js

import React from "react";

// Importando os módulos do Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y, EffectCreative, Autoplay } from "swiper";

import Livros from "../../api/livros";

import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/navigation";
import "swiper/css/pagination";

function EbookSlider() {
  return (
    <div className="ebook-slider-container">
      <Swiper
        effect={"creative"}
        creativeEffect={{
          prev: {
            shadow: false,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, EffectCreative, Pagination, A11y]}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: "auto",
          },
          1024: {
            slidesPerView: "auto",
          },
        }}
      >
        {Livros.slice(0, 8).map((ebook) => (
          <SwiperSlide key={ebook.id} className="ebook-slide">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={ebook.img}
                alt={ebook.title}
                style={{ display: "block", margin: "0 auto", maxWidth: "60%" }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default EbookSlider;
